module.exports = __webpack_public_path__ + "img/woman.ab02536a.svg";